import axiosPrivate from './axiosPrivate';

const getInducciones = (params = {}) => {
  return axiosPrivate.get('inducciones', { params }).then(r => r.data);
};

const crear = (payload) => {
  return axiosPrivate.post('inducciones', payload).then(r => r.data);
};

const finalizar = (payload, documentoFile) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== null && v !== undefined) formData.append(k, v);
  });
  formData.append('documento', documentoFile);
  return axiosPrivate.post('inducciones/finalizar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then(r => r.data);
};

export default {
  getInducciones,
  crear,
  finalizar,
  actualizar: (payload) => {
    return axiosPrivate.put('inducciones', payload).then(r => r.data);
  },
};
